import { INSIDER_CHURNED_MESSAGING_240709 } from "@faire/web-api/indigofair/settings/INSIDER_CHURNED_MESSAGING_240709";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingInsiderChurnedMessaging = (): boolean =>
  getSettingValueWithoutAssignment(INSIDER_CHURNED_MESSAGING_240709, false);
